import { ensureMaxWidthSetting } from "@library/shared";
import { MaxWidthSettingEnum } from "@library/types";
import {
  CarouselAnimationTypeEnum,
  CarouselAutoplaySpeedEnum,
  CarouselContainerEnum,
  CarouselStyleEnum,
  type ICarouselSettings,
  type ICarouselSpecificSettings,
} from "../types";

interface IProps {
  comboSettings?: Record<string, unknown> | null;
  isMobile?: boolean;
}

export const ensureCarouselComboSettings = (
  data: IProps = {},
): ICarouselSettings => {
  const { comboSettings = {}, isMobile = false } = data;
  const {
    carouselStyle,
    carouselContainer,
    carouselBulletsColor,
    carouselBulletsColorActive,
    carouselBulletsOpacity,
    carouselAnimationType,
    carouselAutoplaySpeed,
    carouselAutoplayActive,
    carouselBulletsOpacityActive,
  } = comboSettings as Partial<ICarouselSettings>;

  const baseSettings = {
    horizontalAlignment: "center",
    maxWidth: ensureMaxWidthSetting(
      comboSettings?.maxWidth,
      MaxWidthSettingEnum.narrow,
    ),
    ...comboSettings,
    name: "Carousel",
  };

  const settings: ICarouselSpecificSettings = {
    carouselStyle: CarouselStyleEnum.Regular,
    carouselContainer: CarouselContainerEnum.SideBySide,
    //
    carouselAnimationType: CarouselAnimationTypeEnum.SlideIn,
    carouselAutoplaySpeed: CarouselAutoplaySpeedEnum.Medium,
    carouselAutoplayActive: !!carouselAutoplayActive,
    //
    carouselBulletsColor: carouselBulletsColor ?? "var(--theme-color-1)",
    carouselBulletsColorActive:
      carouselBulletsColorActive ?? "var(--theme-color-1)",
    carouselBulletsOpacity: carouselBulletsOpacity ?? 50,
    carouselBulletsOpacityActive: carouselBulletsOpacityActive ?? 100,
  };

  if (carouselContainer === CarouselContainerEnum.Stacked) {
    settings.carouselContainer = carouselContainer;
  }

  if (carouselStyle === CarouselStyleEnum.FullScreen) {
    settings.carouselStyle = carouselStyle;
  }

  if (carouselAnimationType === CarouselAnimationTypeEnum.FadeIn) {
    settings.carouselAnimationType = CarouselAnimationTypeEnum.FadeIn;
  }

  if (
    carouselAutoplaySpeed &&
    [CarouselAutoplaySpeedEnum.Fast, CarouselAutoplaySpeedEnum.Slow].includes(
      carouselAutoplaySpeed,
    )
  ) {
    settings.carouselAutoplaySpeed = carouselAutoplaySpeed;
  }

  if (isMobile) {
    settings.carouselContainer = CarouselContainerEnum.Stacked;
  }

  return { ...baseSettings, ...settings };
};
